import { Link } from "react-router-dom"
import LinkCircleIcon from "@/components/icons/link-circle"
import PlusLineIcon from "@/components/icons/plus-line"
import Circle from "@/components/layout/circle"
import Stack from "@/components/layout/stack"
import { Button } from "@/components/ui/button"
import DashboardCard from "./card"
import Balance from "./balance"
import PaymentsTable from "@/payments/payments-table"
import { useUser } from "@/api/users"
import Loader from "@/components/layout/loader"
import BalanceCard from "./balance.card"
import Container from "@/components/ui/container"
import InvoiceIcon from "@/components/icons/paper-fold-text"
import WalletIcon from "@/components/icons/wallet"
import ReceiveButton from "@/transactions/receive/receive.button"
import SendButton from "@/transactions/send.button"
import { BackupAlert } from "./backup.alert"

export default function DashboardScreen() {
  const { user } = useUser()

  if (!user) {
    return <Loader message="Loading dashboard..." />
  }

  return (
    <Stack align="stretch">
      <div className="flex flex-col xl:flex-row gap-5 flex-grow">
        {user.hasWallet ? <Balance /> : <BalanceCard />}
        <div className="flex flex-col lg:flex-row gap-5 w-full">
          <DashboardCard
            title="Create Payment Link"
            icon={
              <Circle variant="blue">
                <LinkCircleIcon />
              </Circle>
            }
            button={
              <Button variant="outline" asChild>
                <Link to="/payment-links/create" data-testid="create-link">
                  Create Link
                  <PlusLineIcon />
                </Link>
              </Button>
            }
          />
          <DashboardCard
            title="Create Invoice"
            icon={
              <Circle variant="red">
                <InvoiceIcon />
              </Circle>
            }
            button={
              <Button variant="outline" asChild>
                <Link to="/invoices/create">
                  Create Invoice
                  <PlusLineIcon />
                </Link>
              </Button>
            }
          />
          <DashboardCard
            title="Quick Pay"
            icon={
              <Circle variant="green">
                <WalletIcon />
              </Circle>
            }
            button={
              <>
                <ReceiveButton variant="outline" />
                <SendButton variant="outline" />
              </>
            }
          />
        </div>
      </div>
      <BackupAlert />
      <Container>
        <div className="flex flex-row justify-between items-center pb-4">
          <div className="text-md font-semibold">Recent Payments</div>
          <Button variant="outline" asChild>
            <Link to="/payments">View all payments</Link>
          </Button>
        </div>
        <PaymentsTable />
      </Container>
    </Stack>
  )
}
